var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zoho-user-mapping" },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("a-table", {
            attrs: { dataSource: _vm.dataSource, columns: _vm.columns },
            scopedSlots: _vm._u([
              {
                key: "zohoUser",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      record.zohoUser
                        ? _c("span", [_vm._v(_vm._s(record.zohoUser))])
                        : _c("a-icon", { attrs: { type: "close" } }),
                    ],
                    1
                  )
                },
              },
              {
                key: "mappingType",
                fn: function (text, record) {
                  return _c("span", {}, [
                    record.zohoUser
                      ? _c("span", [_vm._v("Email")])
                      : _c("span", [_vm._v("-")]),
                  ])
                },
              },
              {
                key: "zohoIntegration",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      record.hasZohoChannel
                        ? _c(
                            "a-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeZohoIntegration(record)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.removeZohoLink")) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.connectToZoho(record)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.connectToZoho")) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }